<template>
    <v-navigation-drawer
        v-model="drawer"
        app
        persistent
        mobile-breakpoint="991"
        :mini-variant="miniVariant"
        :expand-on-hover="expandOnHover"
    >

        <v-list>
            <!-- Back option and parent title -->
                <div v-show="back">
                    <v-list-item tag="a" @click="$router.push({ name: back })">
                        <v-list-item-icon>
                            <font-awesome-icon icon="arrow-circle-left"/>
                        </v-list-item-icon>
                        <v-list-item-content link>
                            <v-list-item-title>{{ $t("back") }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-divider></v-divider>
                </div>
            <!-- End Back option and parent title -->
        

            <v-list-item
                v-for="item in items"
                :key="item.to"
                tag="a"
                @click="gotoRoute(item)"
                v-show="item.hasRole"
                :class="$route.name == item.to ? 'v-list-item--active' : ''"
            >
                <v-list-item-icon v-if="item.action"><font-awesome-icon :icon="item.action"/></v-list-item-icon>
                <v-list-item-content link v-if="item.action"><v-list-item-title style="font-size: 20px; font-weight: bold" v-text="$t(item.title)"></v-list-item-title></v-list-item-content>
                <v-list-item-content link v-else><v-list-item-title style="margin-left: 35px;" v-text="$t(item.title)"></v-list-item-title></v-list-item-content>
            </v-list-item>  

        </v-list>

    </v-navigation-drawer>
</template>
<script>
    import POSITION  from "../../constants/position.js";

    export default {
        name: "Drawer",
        props: ["drawerProp", "miniVariantProp"],
        data() {
            return {
                drawer: true,
                offset: false,
                miniVariant: false,
                expandOnHover: false
            };
        },
        watch: {
            drawerProp(val) {
                this.drawer = val;
            },
            drawer(val) {
                this.$emit("getDrawerState", val);
            },
            miniVariantProp(val) {
                this.miniVariant = val;
                this.expandOnHover = val;
            }
        },

        methods: {
            gotoRoute(item){
                this.$router.push({ name: item.to + item.active }).catch(() => {});
            },
        },

        computed: {
            items(){
                let route_name = this.$route.name;
                let route_arrs = route_name.split('.');
                if(route_arrs.length == 1){
                    return this.BEESHOP.filter(obj => {
                        return obj.parent === '';
                    });
                }else if(route_arrs.length > 1){
                    route_name = route_arrs[0] + '.' + route_arrs[1];
                    let current = this.BEESHOP.filter(obj => {
                        return obj.to == route_name && obj.hasChild == true;
                    });

                    if(current.length){
                        let id          = current[0].id;
                        let new_items   = [];

                        let parent = this.BEESHOP.filter(obj => {
                            return obj.parent == id;
                        });

                        if(parent.length){
                            parent.forEach(obj => {
                                new_items.push(obj);

                                let child = this.BEESHOP.filter(beeshop => {
                                    return beeshop.parent === obj.id 
                                });

                                child.forEach(child => {
                                    new_items.push(child);
                                });

                            });
                            
                        }

                        return new_items;
                    }

                }
                return [];               
            },

            back(){
                let route_name = this.$route.name;
                let route_arrs = route_name.split('.');
                if(route_arrs.length > 1) {
                    return route_arrs[0];
                }
                return '';
            },

            BEESHOP(){
                let PREFIX = 'beeshop';
                return [
                /** ================ SECTION A ===============*/
                    {
                        title: "manageSaleAgriInput",
                        action: "balance-scale",
                        to: PREFIX + ".agri-input", 
                        hasRole: [POSITION.FARMER, POSITION.BEE_SHOP, POSITION.BEE_XPRESS, POSITION.BEE_AGENT, POSITION.BEE_DEPO, POSITION.SUPPLIER_AGRI_INPUT, POSITION.SUPPLIER_CONSUMPTION, POSITION.SUPPLIER_RICE, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                        id: 'A01',
                        parent: '',
                        hasChild: true,
                        active: '.order-management.order',
                    },
                    {
                        title: "manageBuyBackCrop",
                        action: "truck",
                        to: PREFIX + ".buyback",
                        hasRole: [POSITION.MILLER, POSITION.EXPORTER, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                        id: 'A02',
                        parent: '',
                        hasChild: true,
                        active: '.buyback-facilitate.request-drawdown',
                    },
                    {
                        title: "manageOutsideEchosystem",
                        action: "database",
                        to: PREFIX + ".outside-business",
                        hasRole: [POSITION.BEE_DEPO, POSITION.BEE_SHOP, POSITION.BEE_XPRESS, POSITION.BEE_AGENT, POSITION.EMPLOYEE].includes(this.$store.state.userDoc.type),
                        id: 'A03',
                        parent: '',
                        hasChild: true,
                        active: '.sale',
                    },
                    {
                        title: "membership",
                        action: "users",
                        to: PREFIX + ".membership",
                        hasRole: [POSITION.BEE_SHOP, POSITION.BEE_XPRESS, POSITION.BEE_AGENT, POSITION.BEE_DEPO, POSITION.SUPPLIER_AGRI_INPUT, POSITION.SUPPLIER_CONSUMPTION, POSITION.SUPPLIER_RICE, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                        id: 'A04',
                        parent: '',
                        hasChild: true,
                        active: '.list-membership',
                    },
                    // {
                    //     title: "memberRegistration",
                    //     action: "user-edit",
                    //     to: PREFIX + ".member-registration",
                    //     hasRole: [POSITION.BEE_SHOP, POSITION.BEE_XPRESS, POSITION.BEE_AGENT, POSITION.BEE_DEPO, POSITION.SUPPLIER_AGRI_INPUT, POSITION.SUPPLIER_CONSUMPTION, POSITION.SUPPLIER_RICE, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                    //     id: 'A04',
                    //     parent: '',
                    //     hasChild: true,
                    //     active: '',
                    // },
                    // {
                    //     title: "setting",
                    //     action: "cog",
                    //     to: PREFIX + ".setting",
                    //     hasRole: [POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                    //     id: 'A05',
                    //     parent: '',
                    //     hasChild: true,
                    //     active: '.product',
                    // },
                    // {
                    //     title: "manageSaleAsset",
                    //     action: "basketball-ball",
                    //     to: PREFIX + ".setting",
                    //     hasRole: [POSITION.FARMER, POSITION.BEE_SHOP, POSITION.BEE_XPRESS, POSITION.BEE_AGENT, POSITION.BEE_DEPO, POSITION.SUPPLIER_AGRI_INPUT, POSITION.SUPPLIER_CONSUMPTION, POSITION.SUPPLIER_RICE, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                    //     id: 'A06',
                    //     parent: '',
                    //     hasChild: true,
                    //     active: '.sale-asset',
                    // },
                    // {
                    //     title: "manageReport",
                    //     action: "chart-line",
                    //     to: PREFIX + ".report",
                    //     hasRole: [POSITION.FARMER, POSITION.BEE_SHOP, POSITION.BEE_XPRESS, POSITION.BEE_AGENT, POSITION.BEE_DEPO, POSITION.SUPPLIER_AGRI_INPUT, POSITION.SUPPLIER_CONSUMPTION,  POSITION.SUPPLIER_RICE, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                    //     id: 'A07',
                    //     parent: '',
                    //     hasChild: true,
                    //     active: '.product',
                    // },
                /** ================ END SECTION A ===============*/

                /** ================ SECTION B ===============*/
                    {
                        title: "orderManagement",
                        action: "shopping-basket",
                        to: PREFIX + ".agri-input.order-management",
                        hasRole: [POSITION.FARMER, POSITION.BEE_SHOP, POSITION.BEE_XPRESS, POSITION.BEE_AGENT, POSITION.BEE_DEPO, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                        id: 'AO1B01',
                        parent: 'A01',
                        hasChild: true,
                        active: '.order',
                    },
                    {
                        title: "orderFarmerManagement",
                        action: "user-secret",
                        to: PREFIX + ".agri-input.order-farmer-management",
                        hasRole: [POSITION.FARMER, POSITION.BEE_SHOP, POSITION.BEE_XPRESS, POSITION.BEE_AGENT, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                        id: 'AO1B02',
                        parent: 'A01',
                        hasChild: true,
                        active: '.order',
                    },
                    {
                        title: "saleManagement",
                        action: "gift",
                        to: PREFIX + ".agri-input.sale-management",
                        hasRole: [POSITION.BEE_SHOP, POSITION.BEE_XPRESS, POSITION.BEE_AGENT, POSITION.BEE_DEPO, POSITION.SUPPLIER_AGRI_INPUT, POSITION.SUPPLIER_CONSUMPTION, POSITION.SUPPLIER_RICE].includes(this.$store.state.userDoc.type),
                        id: 'AO1B03',
                        parent: 'A01',
                        hasChild: true,
                        active: '.sale',
                    },
                    {//stock transfer
                        title: "stockTransfer",
                        action: "sync-alt",
                        to: PREFIX + ".agri-input.stock-transfer",
                        hasRole: [POSITION.BEE_SHOP, POSITION.BEE_XPRESS, POSITION.BEE_AGENT, POSITION.BEE_DEPO, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                        id: 'AO1B04',
                        parent: 'A01',
                        hasChild: true,
                        active: '.stock-transfer-request',
                    },
                    {//stock reconcile
                        title: "stockReconciling",
                        action: "coins",
                        to: PREFIX + ".agri-input.stock-reconcile",
                        hasRole: [POSITION.BEE_SHOP, POSITION.BEE_XPRESS, POSITION.BEE_AGENT, POSITION.BEE_DEPO, POSITION.SUPPLIER_AGRI_INPUT, POSITION.SUPPLIER_CONSUMPTION, POSITION.SUPPLIER_RICE, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                        id: 'AO1B06',
                        parent: 'A01',
                        hasChild: true,
                        active: '.stock-reconcile',
                    },
                    {
                        title: "reporting",
                        action: "file-alt",
                        to: PREFIX + ".agri-input.reporting",
                        hasRole: [POSITION.BEE_SHOP, POSITION.BEE_XPRESS, POSITION.BEE_AGENT, POSITION.BEE_DEPO, POSITION.SUPPLIER_AGRI_INPUT, POSITION.SUPPLIER_CONSUMPTION, POSITION.SUPPLIER_CONSUMPTION, POSITION.SUPPLIER_RICE, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                        id: 'AO1B05',
                        parent: 'A01',
                        hasChild: true,
                        active: '.report',
                    },
                    { // buyback section
                        title: "facilitate",
                        action: "money-check-alt",
                        to: PREFIX + ".buyback.buyback-facilitate",
                        hasRole: [POSITION.MILLER, POSITION.EXPORTER, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                        id: 'AO2B01',
                        parent: 'A02',
                        hasChild: true,
                        active: '.request-drawdown',

                    },
                    {
                        title: "invoiceFinancing",
                        action: "sync-alt",
                        to: PREFIX + ".buyback.buyback-invoice-financing",
                        hasRole: [POSITION.MILLER, POSITION.EXPORTER, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                        id: 'AO2B02',
                        parent: 'A02',
                        hasChild: true,
                        active: '.request-drawdown-creditline',
                    },
                    {
                        title: "revolvingCredits",
                        action: "money-bill-alt",
                        to: PREFIX + ".buyback.revolving-credit",
                        hasRole: [POSITION.MILLER, POSITION.EXPORTER, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                        id: 'AO2B04',
                        parent: 'A02',
                        hasChild: true,
                        active: '.request-drawdown-creditline',
                    },
                    {
                        title: "trading",
                        action: "shopping-basket",
                        to: PREFIX + ".buyback.buyback-trading",
                        hasRole: [POSITION.MILLER, POSITION.EXPORTER, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                        id: 'AO2B03',
                        parent: 'A02',
                        hasChild: true,
                        active: '',
                    },
                    { // outside business
                        title: "sale",
                        action: "shopping-basket",
                        to: PREFIX + ".outside-business.sale",
                        hasRole: [POSITION.BEE_DEPO, POSITION.BEE_SHOP, POSITION.BEE_XPRESS, POSITION.BEE_AGENT, POSITION.EMPLOYEE].includes(this.$store.state.userDoc.type),
                        id: 'AO3B01',
                        parent: 'A03',
                        hasChild: false,
                        active: '',
                    },
                    {
                        title: "paidInvoice",
                        action: "money-check-alt",
                        to: PREFIX + ".outside-business.sale-paid",
                        hasRole: [POSITION.BEE_DEPO, POSITION.BEE_SHOP, POSITION.BEE_XPRESS, POSITION.BEE_AGENT, POSITION.EMPLOYEE].includes(this.$store.state.userDoc.type),
                        id: 'AO3B02',
                        parent: 'A03',
                        hasChild: false,
                        active: '',
                    },
                    {
                        title: "purchasing",
                        action: "truck",
                        to: PREFIX + ".outside-business.purchasing",
                        hasRole: [POSITION.BEE_DEPO, POSITION.BEE_SHOP, POSITION.BEE_XPRESS, POSITION.BEE_AGENT, POSITION.EMPLOYEE].includes(this.$store.state.userDoc.type),
                        id: 'AO3B03',
                        parent: 'A03',
                        hasChild: false,
                        active: '',
                    },
                    {
                        title: "stockReconcile",
                        action: "cubes",
                        to: PREFIX + ".outside-business.stock-reconcile",
                        hasRole: [POSITION.BEE_DEPO, POSITION.BEE_SHOP, POSITION.BEE_XPRESS, POSITION.BEE_AGENT, POSITION.EMPLOYEE].includes(this.$store.state.userDoc.type),
                        id: 'AO3B04',
                        parent: 'A03',
                        hasChild: false,
                        active: '',
                    },
                    {
                        title: "stockReconcileList",
                        action: "list",
                        to: PREFIX + ".outside-business.stock-list",
                        hasRole: [POSITION.BEE_DEPO, POSITION.BEE_SHOP, POSITION.BEE_XPRESS, POSITION.BEE_AGENT, POSITION.EMPLOYEE].includes(this.$store.state.userDoc.type),
                        id: 'AO3B05',
                        parent: 'A03',
                        hasChild: false,
                        active: '',
                    },
                    {
                        title: "stockRegistration",
                        action: "edit",
                        to: PREFIX + ".outside-business.stock-registration",
                        hasRole: [POSITION.BEE_DEPO, POSITION.BEE_SHOP, POSITION.BEE_XPRESS, POSITION.BEE_AGENT, POSITION.EMPLOYEE].includes(this.$store.state.userDoc.type),
                        id: 'AO3B06',
                        parent: 'A03',
                        hasChild: false,
                        active: '',
                    },
                    { // Membership
                        title: "listMembership",
                        action: "list",
                        to: PREFIX + ".membership.list-membership",
                        hasRole: [POSITION.BEE_SHOP, POSITION.BEE_XPRESS, POSITION.BEE_AGENT, POSITION.BEE_DEPO, POSITION.SUPPLIER_AGRI_INPUT, POSITION.SUPPLIER_CONSUMPTION, POSITION.SUPPLIER_RICE, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                        id: 'AO4B01',
                        parent: 'A04',
                        hasChild: false,
                        active: '',
                    },
                    { // settings
                        title: "product",
                        action: "cubes",
                        to: PREFIX + ".setting.product",
                        hasRole: [POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                        id: 'AO5B01',
                        parent: 'A05',
                        hasChild: false,
                        active: '',
                    },
                    {
                        title: "unit",
                        action: "filter",
                        to: PREFIX + ".setting.unit",
                        hasRole: [POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                        id: 'AO5B02',
                        parent: 'A05',
                        hasChild: false,
                        active: '',
                    },
                    {
                        title: "category",
                        action: "list",
                        to: PREFIX + ".setting.category",
                        hasRole: [POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                        id: 'AO5B03',
                        parent: 'A05',
                        hasChild: false,
                        active: '',
                    },
                /** ================ END SECTION B ===============*/

                /** ================ SECTION C ===============*/
                    { // order
                        title: "order",
                        action: "",
                        to: PREFIX + ".agri-input.order-management.order",
                        hasRole: [POSITION.FARMER, POSITION.BEE_SHOP, POSITION.BEE_XPRESS, POSITION.BEE_AGENT, POSITION.BEE_DEPO, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                        id: 'AO1B01C01',
                        parent: 'AO1B01',
                        hasChild: false,
                        active: '',
                    },
                    {
                        title: "orderList",
                        action: "",
                        to: PREFIX + ".agri-input.order-management.order-list",
                        hasRole: [POSITION.FARMER, POSITION.BEE_SHOP, POSITION.BEE_XPRESS, POSITION.BEE_AGENT, POSITION.BEE_DEPO, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                        id: 'AO1B01C02',
                        parent: 'AO1B01',
                        hasChild: false,
                        active: '',
                    },
                    {
                        title: "deliveryBoard",
                        action: "",
                        to: PREFIX + ".agri-input.order-management.delivery-board",
                        hasRole: [POSITION.FARMER, POSITION.BEE_SHOP, POSITION.BEE_XPRESS, POSITION.BEE_AGENT, POSITION.BEE_DEPO, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                        id: 'AO1B01C03',
                        parent: 'AO1B01',
                        hasChild: false,
                        active: '',
                    },
                    {
                        title: "invoice",
                        action: "",
                        to: PREFIX + ".agri-input.order-management.order-payment-board",
                        hasRole: [POSITION.FARMER, POSITION.BEE_SHOP, POSITION.BEE_XPRESS, POSITION.BEE_AGENT, POSITION.BEE_DEPO, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                        id: 'AO1B01C04',
                        parent: 'AO1B01',
                        hasChild: false,
                        active: '',
                    },
                    {
                        title: "paidInvoice",
                        action: "",
                        to: PREFIX + ".agri-input.order-management.order-transaction-paid",
                        hasRole: [POSITION.FARMER, POSITION.BEE_SHOP, POSITION.BEE_XPRESS, POSITION.BEE_AGENT, POSITION.BEE_DEPO, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                        id: 'AO1B01C05',
                        parent: 'AO1B01',
                        hasChild: false,
                        active: '',
                    },
                    { //farmer order
                        title: "order",
                        action: "",
                        to: PREFIX + ".agri-input.order-farmer-management.order",
                        hasRole: [POSITION.FARMER, POSITION.BEE_SHOP, POSITION.BEE_XPRESS, POSITION.BEE_AGENT, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                        id: 'AO1B02C01',
                        parent: 'AO1B02',
                        hasChild: false,
                        active: '',
                    },
                    {
                        title: "orderList",
                        action: "",
                        to: PREFIX + ".agri-input.order-farmer-management.order-list",
                        hasRole: [POSITION.FARMER, POSITION.BEE_SHOP, POSITION.BEE_XPRESS, POSITION.BEE_AGENT, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                        id: 'AO1B02C02',
                        parent: 'AO1B02',
                        hasChild: false,
                        active: '',
                    },
                    {
                        title: "productTakeOut",
                        action: "",
                        to: PREFIX + ".agri-input.order-farmer-management.product-take-out",
                        hasRole: [POSITION.FARMER, POSITION.BEE_SHOP, POSITION.BEE_XPRESS, POSITION.BEE_AGENT, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                        id: 'AO1B02C03',
                        parent: 'AO1B02',
                        hasChild: false,
                        active: '',
                    },
                    {
                        title: "invoice",
                        action: "",
                        to: PREFIX + ".agri-input.order-farmer-management.farmer-payment-board",
                        hasRole: [POSITION.FARMER, POSITION.BEE_SHOP, POSITION.BEE_XPRESS, POSITION.BEE_AGENT, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                        id: 'AO1B02C04',
                        parent: 'AO1B02',
                        hasChild: false,
                        active: '',
                    },
                    {
                        title: "paidInvoice",
                        action: "",
                        to: PREFIX + ".agri-input.order-farmer-management.farmer-transaction-paid",
                        hasRole: [POSITION.FARMER, POSITION.BEE_SHOP, POSITION.BEE_XPRESS, POSITION.BEE_AGENT, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                        id: 'AO1B02C05',
                        parent: 'AO1B02',
                        hasChild: false,
                        active: '',
                    },
                    { // sale management
                        title: "sale",
                        action: "",
                        to: PREFIX + ".agri-input.sale-management.sale",
                        hasRole: [POSITION.BEE_SHOP, POSITION.BEE_XPRESS, POSITION.BEE_AGENT, POSITION.BEE_DEPO, POSITION.SUPPLIER_AGRI_INPUT, POSITION.SUPPLIER_CONSUMPTION, POSITION.SUPPLIER_RICE].includes(this.$store.state.userDoc.type),
                        id: 'AO1B03C01',
                        parent: 'AO1B03',
                        hasChild: false,
                        active: '',
                    },
                    {
                        title: "deliveryNote",
                        action: "",
                        to: PREFIX + ".agri-input.sale-management.delivery-note",
                        hasRole: [POSITION.BEE_SHOP, POSITION.BEE_XPRESS, POSITION.BEE_AGENT, POSITION.BEE_DEPO, POSITION.SUPPLIER_AGRI_INPUT, POSITION.SUPPLIER_CONSUMPTION, POSITION.SUPPLIER_RICE].includes(this.$store.state.userDoc.type),
                        id: 'AO1B03C02',
                        parent: 'AO1B03',
                        hasChild: false,
                        active: '',
                    },
                    {
                        title: "invoice",
                        action: "",
                        to: PREFIX + ".agri-input.sale-management.sale-payment-board",
                        hasRole: [POSITION.BEE_SHOP, POSITION.BEE_XPRESS, POSITION.BEE_AGENT, POSITION.BEE_DEPO, POSITION.SUPPLIER_AGRI_INPUT, POSITION.SUPPLIER_CONSUMPTION, POSITION.SUPPLIER_RICE].includes(this.$store.state.userDoc.type),
                        id: 'AO1B03C03',
                        parent: 'AO1B03',
                        hasChild: false,
                        active: '',
                    },
                    {
                        title: "paidInvoice",
                        action: "",
                        to: PREFIX + ".agri-input.sale-management.sale-transaction-paid",
                        hasRole: [POSITION.BEE_SHOP, POSITION.BEE_XPRESS, POSITION.BEE_AGENT, POSITION.BEE_DEPO, POSITION.SUPPLIER_AGRI_INPUT, POSITION.SUPPLIER_CONSUMPTION, POSITION.SUPPLIER_RICE].includes(this.$store.state.userDoc.type),
                        id: 'AO1B03C04',
                        parent: 'AO1B03',
                        hasChild: false,
                        active: '',
                    },
                    { // stock transfer management
                        title: "requestStockTransfer",
                        action: "",
                        to: PREFIX + ".agri-input.stock-transfer.stock-transfer-request",
                        hasRole: [POSITION.BEE_SHOP, POSITION.BEE_XPRESS, POSITION.BEE_AGENT, POSITION.BEE_DEPO, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                        id: 'AO1B04C01',
                        parent: 'AO1B04',
                        hasChild: false,
                        active: '',
                    },
                    {
                        title: "receiveStockTransfer",
                        action: "",
                        to: PREFIX + ".agri-input.stock-transfer.stock-transfer-receive",
                        hasRole: [POSITION.BEE_SHOP, POSITION.BEE_XPRESS, POSITION.BEE_AGENT, POSITION.BEE_DEPO, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                        id: 'AO1B04C02',
                        parent: 'AO1B04',
                        hasChild: false,
                        active: '',
                    },
                    // {
                    //     title: "invoice",
                    //     action: "",
                    //     to: PREFIX + ".agri-input.stock-transfer.receive-payment-board",
                    //     hasRole: [POSITION.BEE_SHOP, POSITION.BEE_XPRESS, POSITION.BEE_AGENT, POSITION.BEE_DEPO, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                    //     id: 'AO1B04C03',
                    //     parent: 'AO1B04',
                    //     hasChild: false,
                    //     active: '',
                    // },
                    {
                        title: "paidInvoice",
                        action: "",
                        to: PREFIX + ".agri-input.stock-transfer.receive-transaction-paid",
                        hasRole: [POSITION.BEE_SHOP, POSITION.BEE_XPRESS, POSITION.BEE_AGENT, POSITION.BEE_DEPO, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                        id: 'AO1B04C04',
                        parent: 'AO1B04',
                        hasChild: false,
                        active: '',
                    },
                    {//stock reconcile
                        title: "stockReconcile",
                        action: "",
                        to: PREFIX + ".agri-input.stock-reconcile.stock-reconcile",
                        hasRole: [POSITION.BEE_SHOP, POSITION.BEE_XPRESS, POSITION.BEE_AGENT, POSITION.BEE_DEPO, POSITION.SUPPLIER_AGRI_INPUT, POSITION.SUPPLIER_CONSUMPTION, POSITION.SUPPLIER_RICE, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                        id: 'AO1B06C01',
                        parent: 'AO1B06',
                        hasChild: false,
                        active: '',
                    },
                    {
                        title: "stockList",
                        action: "",
                        to: PREFIX + ".agri-input.stock-reconcile.stock-reconcile-list",
                        hasRole: [POSITION.BEE_SHOP, POSITION.BEE_XPRESS, POSITION.BEE_AGENT, POSITION.BEE_DEPO, POSITION.SUPPLIER_AGRI_INPUT, POSITION.SUPPLIER_CONSUMPTION, POSITION.SUPPLIER_RICE, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                        id: 'AO1B06C02',
                        parent: 'AO1B06',
                        hasChild: false,
                        active: '',
                    },
                    {
                        title: "invoice",
                        action: "",
                        to: PREFIX + ".agri-input.stock-reconcile.stock-reconcile-invoice",
                        hasRole: [POSITION.BEE_SHOP, POSITION.BEE_XPRESS, POSITION.BEE_AGENT, POSITION.BEE_DEPO, POSITION.SUPPLIER_AGRI_INPUT, POSITION.SUPPLIER_CONSUMPTION, POSITION.SUPPLIER_RICE, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                        id: 'AO1B06C03',
                        parent: 'AO1B06',
                        hasChild: false,
                        active: '',
                    },

                    // {
                    //     title: "stockTransferInvoice",
                    //     action: "",
                    //     to: PREFIX + ".agri-input.stock-transfer.stock-transfer-payment",
                    //     hasRole: [POSITION.BEE_SHOP, POSITION.BEE_XPRESS, POSITION.BEE_AGENT, POSITION.BEE_DEPO, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                    //     id: 'AO1B04C03',
                    //     parent: 'AO1B04',
                    //     hasChild: false,
                    //     active: '',
                    // },
                    { // Report management
                        title: "reporting",
                        action: "",
                        to: PREFIX + ".agri-input.reporting.report",
                        hasRole: [POSITION.BEE_SHOP, POSITION.BEE_XPRESS, POSITION.BEE_AGENT, POSITION.BEE_DEPO, POSITION.SUPPLIER_AGRI_INPUT, POSITION.SUPPLIER_CONSUMPTION, POSITION.SUPPLIER_RICE, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                        id: 'AO1B05C01',
                        parent: 'AO1B05',
                        hasChild: false,
                        active: '',
                    },
                    { // buyback facilitate
                        title: "requestDrawDown",
                        action: "",
                        to: PREFIX + ".buyback.buyback-facilitate.request-drawdown",
                        hasRole: [POSITION.MILLER, POSITION.EXPORTER, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                        id: 'AO2B01C01',
                        parent: 'AO2B01',
                        hasChild: false,
                        active: '',
                    },

                    {
                        title: "createInvoice",
                        action: "",
                        to: PREFIX + ".buyback.buyback-facilitate.buyback-transaction",
                        hasRole: [POSITION.MILLER, POSITION.EXPORTER, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                        id: 'AO2B01C02',
                        parent: 'AO2B01',
                        hasChild: false,
                        active: '',
                    },
                    {
                        title: "paidInvoice",
                        action: "",
                        to: PREFIX + ".buyback.buyback-facilitate.buyback-transaction-paid",
                        hasRole: [POSITION.MILLER, POSITION.EXPORTER, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                        id: 'AO2B01C03',
                        parent: 'AO2B01',
                        hasChild: false,
                        active: '',
                    },
                    {
                        title: "report",
                        action: "",
                        to: PREFIX + ".buyback.buyback-facilitate.buyback-report",
                        hasRole: [POSITION.MILLER, POSITION.EXPORTER, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                        id: 'AO2B01C04',
                        parent: 'AO2B01',
                        hasChild: false,
                        active: '',
                    },
                    { // buyback invoice financing
                        title: "requestDrawDownCreditLine",
                        action: "",
                        to: PREFIX + ".buyback.buyback-invoice-financing.request-drawdown-creditline",
                        hasRole: [POSITION.MILLER, POSITION.EXPORTER, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                        id: 'AO2B02C01',
                        parent: 'AO2B02',
                        hasChild: false,
                        active: '',
                    },
                    { // buyback trading
                        title: "cropCollectPlaning",
                        action: "",
                        to: PREFIX + ".buyback.buyback-trading.crop-collect-planing",
                        hasRole: [POSITION.MILLER, POSITION.EXPORTER, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                        id: 'AO2B03C01',
                        parent: 'AO2B03',
                        hasChild: false,
                        active: '',
                    },
                    {
                        title: "invoiceDraft",
                        action: "",
                        to: PREFIX + ".buyback.buyback-trading.invoice-draft",
                        hasRole: [POSITION.MILLER, POSITION.EXPORTER, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                        id: 'AO2B03C02',
                        parent: 'AO2B03',
                        hasChild: false,
                        active: '',
                    },
                    {
                        title: "purchase_paddy",
                        action: "",
                        to: PREFIX + ".buyback.buyback-trading.purchase",
                        hasRole: [POSITION.MILLER, POSITION.EXPORTER, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                        id: 'AO2B03C03',
                        parent: 'AO2B03',
                        hasChild: false,
                        active: '',
                    },
                    {
                        title: "paymentVourcher",
                        action: "",
                        to: PREFIX + ".buyback.buyback-trading.payment-vourcher",
                        hasRole: [POSITION.MILLER, POSITION.EXPORTER, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                        id: 'AO2B03C05',
                        parent: 'AO2B03',
                        hasChild: false,
                        active: '',
                    },
                    {
                        title: "sale_paddy",
                        action: "",
                        to: PREFIX + ".buyback.buyback-trading.sale",
                        hasRole: [POSITION.MILLER, POSITION.EXPORTER, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                        id: 'AO2B03C06',
                        parent: 'AO2B03',
                        hasChild: false,
                        active: '',
                    },
                    {
                        title: "receiptVourcher",
                        action: "",
                        to: PREFIX + ".buyback.buyback-trading.receipt-vourcher",
                        hasRole: [POSITION.MILLER, POSITION.EXPORTER, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                        id: 'AO2B03C07',
                        parent: 'AO2B03',
                        hasChild: false,
                        active: '',
                    },
                    {
                      title: "requestDrawDownRevolvingCredit",
                      action: "",
                      to: PREFIX + ".buyback.revolving-credit.request_drawdown_revolving_credit",
                      hasRole: [POSITION.MILLER, POSITION.EXPORTER, POSITION.EMPLOYEE, POSITION.BEE_OPERATOR].includes(this.$store.state.userDoc.type),
                      id: 'AO2B04C01',
                      parent: 'AO2B04',
                      hasChild: false,
                      active: '',
                    },
                /** ================ END SECTION C ===============*/
                ]
            }
        },
        
       
    };
</script>